//region Селект выбора языка
window.addEventListener('load', () => {
  customSelect('.lang-select select');
  const langSelect = document.querySelectorAll('.lang-select select');
  [...langSelect].map(select => {
    const customSelectOpener = select.previousElementSibling;
    customSelectOpener.setAttribute('data-value', select.value);
    select.addEventListener('change', (e) => {
      customSelectOpener.setAttribute('data-value', e.target.value);

      const currentPath = window.location.pathname;
      const currentPathParameters = window.location.search;

      console.log('currentPath', currentPath);
      console.log('currentPathParameters', currentPathParameters);

      if (e.target.value && e.target.value == 'russian') {
        window.location = 'https://hooom.poker' + currentPathParameters;
      }
      else {
        if (currentPath === '/') {
          window.location = 'https://hooom.poker/en' + currentPathParameters;
        } else {
          window.location = 'https://hooom.poker/en' + currentPath + currentPathParameters;
        }
      }
    })
  })
});
//endregion